export * from "./dictionary.mjs";
export * from "./formatting/index.mjs";
export * from "./locales/index.mjs";
import * as _translations from "./messages/index.mjs";
export { _translations as translations };